import axios from 'axios';
import { LTI_1P3_PUT_ASSIGNMENT } from '../../constants/endpoints';

const deleteLti1p3Assignment = (spaceId, assignmentId) =>
  axios.delete(LTI_1P3_PUT_ASSIGNMENT({ spaceId, assignmentId }), {
    withCredentials: true,
  });

export default deleteLti1p3Assignment;
